'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// https://stackoverflow.com/questions/260857/changing-website-favicon-dynamically
var setFavicon = function setFavicon(faviconUrl) {
  var link = document.querySelector("link[rel*='icon']") || document.createElement('link');

  link.type = 'image/x-icon';
  link.rel = 'shortcut icon';
  link.href = faviconUrl;

  document.getElementsByTagName('head')[0].appendChild(link);
};

exports.default = setFavicon;